<template>
  <div id="product-configurator" :class="[configurationsLength > 3 || toSetGrid ? 'flex-space' : null]">
    <div ref="rows" class="rows">
      <template v-for="(configurationGroup, index) of configurationGroups">
        <Rule v-if="configurationGroup != null" :key="index" :configurationGroup="configurationGroup" class="configuration" @input="onInput"> </Rule>
        <div v-else :key="index" class="vertical-divider"></div>
      </template>
    </div>
    <hr id="divider-config" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { MediaUtils } from '@article/pixel';
import Rule from './RuleBlock.vue';

export default {
  name: 'Configurator',
  components: {
    Rule,
  },
  data() {
    return {
      isMobileAndSmaller: false,
      isDesktopAndGreater: false,
      toSetGrid: false,
    };
  },
  computed: {
    ...mapGetters('product', [
      'configurations', //
      'configurationsLength',
    ]),
    configurationGroups() {
      if (this.isMobileAndSmaller) {
        return this.configurations.flatMap((value, index) => [value, null]).slice(0, -1);
      }
      if (this.configurationsLength <= 3 && !this.toSetGrid) {
        return this.configurations.flatMap((value, index) => [value, null]).slice(0, -1);
      }
      const factor = this.isDesktopAndGreater ? 4 : 2;
      const arr = this.configurations.flatMap((value, index) => ((index + 1) % factor ? [value, null] : [value]));

      if (this.configurationsLength % factor) {
        return arr.slice(0, -1);
      }
      return arr;
    },
  },
  mounted() {
    this.onWindowSize();
    window.addEventListener('resize', this.onWindowSize);
  },
  destroyed() {
    window.removeEventListener('resize', this.onWindowSize);
  },
  methods: {
    onWindowSize() {
      this.isMobileAndSmaller = MediaUtils.isMobileAndSmaller;
      const smallDesktopBreakpoint = 1200;
      this.isDesktopAndGreater = window.innerWidth > smallDesktopBreakpoint - 1;
      this.toSetGrid = MediaUtils.isMobileAndGreater && (MediaUtils.isTabletAndSmaller || this.$refs.rows.clientHeight > 125);
    },

    onInput() {
      this.$emit('input');
    }
  },
};
</script>

<style lang="scss">
@import '~@article/pixel/dist/style/variables';

#product-configurator {
  position: relative;

  #divider-config {
    margin: 8px 0px 30px;
  }

  &.flex-space {
    @media (min-width: $mobile-breakpoint) {
      .rows {
        flex-wrap: wrap;
        overflow: initial;

        .configuration {
          flex: 1 0 33%;
        }
      }
    }

    @media (min-width: $desktop-breakpoint) {
      .rows {
        .configuration {
          flex: 1 0 20%;
          max-width: 30%;
        }
      }
    }
  }

  .cover-transition-enter,
  .cover-transition-leave-to {
    opacity: 0;
  }

  .cover-transition-enter-active,
  .cover-transition-leave-active {
    transition: opacity ease-in-out 300ms;
  }

  .cover {
    position: absolute;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 42;
    top: -20px;
    left: 0;
    width: 100%;
    height: 100%;

    span {
      color: white;
    }
  }

  .rows {
    display: flex;
    overflow: hidden;

    > * {
      transform: translateZ(0);
      margin-bottom: 12px;
      transition: opacity ease-out 300ms, margin-top ease-out 300ms;
    }

    @media (max-width: $mobile-breakpoint - 1) {
      flex-direction: column;
      flex-wrap: unset;
      max-height: initial;
    }

    .vertical-divider {
      margin: 4px 20px;
      border-right: 1px solid rgba(221, 221, 221, 0.8);

      @media (max-width: $mobile-breakpoint - 1) {
        margin: 12px 0px;
        border-top: 1px solid rgba(221, 221, 221, 0.75);
      }
    }
  }

  @media (max-width: $mobile-breakpoint - 1) {
    .rows {
      overflow: initial !important;
    }
  }

  @media (max-width: $tablet-breakpoint - 1) {
    #divider-config {
      opacity: 0;
      margin: 0px;
      margin-bottom: 12px;
    }
  }
}
</style>
